import gql from 'graphql-tag'

export const updateUser = (user_id, user) => ({
	mutation: gql`
		mutation ($user_id: bigint!, $user: users_set_input!) {
			update_users_by_pk(pk_columns: { id: $user_id }, _set: $user) {
				id
			}
		}
	`,
	variables: { user_id, user }
})
